import CommercialEvaluationsView from '@src/main/modules/reports/ui/components/CommercialEvaluationsView';
import FlightEvaluationsView from '@src/main/modules/reports/ui/components/FlightEvaluationsView';
import { FC } from 'react';

interface EvaluationsTabContentProps {
  activeIndex: number;
  className?: string;
}

const EvaluationsTabContent: FC<EvaluationsTabContentProps> = ({ activeIndex, className }) => {
  const getContent = () => {
    switch (activeIndex) {
      case 0:
        return <CommercialEvaluationsView key="commercial" />;
      case 1:
        return <FlightEvaluationsView key="flight" />;
      default:
        return null;
    }
  };

  return <div className={className}>{getContent()}</div>;
};

export default EvaluationsTabContent;
